import { Link } from "react-router-dom";
import "../styles/Header.css";

const Header = () => {
  return (
    <header className="header">
      <div className="nav-container">
        <Link to="/" className="logo">
          NERD
        </Link>
        <nav className="nav-links">
          <Link to="/about">About</Link>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/services">Services</Link>
          <Link to="/contact">Contact</Link>
          <a
            href="https://www.showbothrows.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Both Rows
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
